import axios from 'axios'

const ACCESS_TOKEN_KEY = 'bekat_kb_access_token'

export const api = axios.create({
  baseURL: '/api/v1',
  withCredentials: true,
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' },
})

function shouldAttemptRefresh(url) {
  if (!url) return false
  if (url.includes('/auth/')) return false
  return true
}

let accessToken = localStorage.getItem(ACCESS_TOKEN_KEY) || null
let refreshPromise = null

export function getAccessToken() {
  return accessToken
}

export function setAccessToken(token) {
  accessToken = token
  if (token) {
    localStorage.setItem(ACCESS_TOKEN_KEY, token)
  } else {
    localStorage.removeItem(ACCESS_TOKEN_KEY)
  }
}

export function clearAccessToken() {
  setAccessToken(null)
}

api.interceptors.request.use((config) => {
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`
  }
  return config
})

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config
    if (!original || original._retry) {
      return Promise.reject(error)
    }

    if (error.response?.status === 401 && shouldAttemptRefresh(original.url)) {
      original._retry = true
      try {
        if (!refreshPromise) {
          refreshPromise = api.post('/auth/refresh').finally(() => {
            refreshPromise = null
          })
        }
        const { data } = await refreshPromise
        setAccessToken(data.access_token)
        original.headers.Authorization = `Bearer ${data.access_token}`
        return api(original)
      } catch (refreshError) {
        clearAccessToken()
        window.dispatchEvent(new Event('bekat-kb:unauthorized'))
        return Promise.reject(refreshError)
      }
    }
    return Promise.reject(error)
  },
)
